import { createSlice } from '@reduxjs/toolkit';
import { FEATURE_NAME } from './constants';
import { IntegrationsState } from 'src/redesign/pages/IntegrationsPage/types';
import {
  getOrganizations,
  integrationDisconnect,
  saveNewIntegration,
} from 'src/redesign/pages/IntegrationsPage/store/actions';

const initialState: IntegrationsState = {
  integrations: null,
  organization: null,
  disconnecting: false,
  error: null,
  loading: false,
  connecting: false,
};

export const integrationsSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(integrationDisconnect.fulfilled, (state) => {
      state.error = null;
      state.disconnecting = false;
    });

    builder.addCase(integrationDisconnect.pending, (state) => {
      state.error = null;
      state.disconnecting = true;
    });

    builder.addCase(integrationDisconnect.rejected, (state, action) => {
      state.error = action.error.message;
      state.disconnecting = false;
    });
    builder.addCase(getOrganizations.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.organization = action.payload.data;
    });
    builder.addCase(getOrganizations.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getOrganizations.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });

    builder.addCase(saveNewIntegration.fulfilled, (state) => {
      state.error = null;
      state.connecting = false;
    });

    builder.addCase(saveNewIntegration.pending, (state) => {
      state.error = null;
      state.connecting = true;
    });

    builder.addCase(saveNewIntegration.rejected, (state, action) => {
      state.error = action.error.message;
      state.connecting = false;
    });
  },
});
